import { LazyPageLoading } from '@components/lazy-page-loading'
import { lazy, Suspense } from 'react'

const BillPay = lazy(() =>
  import('@pages/bill-pay/bill-pay').then((module) => ({
    default: module.BillPay,
  })),
)

export const BillPayRoute = () => (
  <Suspense fallback={<LazyPageLoading />}>
    <BillPay />
  </Suspense>
)
